/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue";
import Group from "vux/src/components/group/index.vue";
import Qrcode from "vux/src/components/qrcode/index.vue";
import Vue from 'vue';
import { Dialog } from 'vant'; // 全局注册

Vue.use(Dialog);
export default {
  name: 'VisitPermit',
  components: {
    Cell: Cell,
    Group: Group,
    Qrcode: Qrcode
  },
  data: function data() {
    return {
      visitType: '',
      currDate: '',
      visitor: {},
      //来访信息
      register: {},
      //注册信息
      busFlag: ['1'],
      inviteCompany: this.$utils.Store.getItem('orgName'),
      //邀请公司
      dicList: [{
        name: '拒绝',
        value: '0'
      }, {
        name: '允许',
        value: '1'
      }],
      isOperate: true,
      value: '',
      xh: '',
      saveImgUrl: ''
    };
  },
  computed: {},
  methods: {
    // 取消访问（翅翼钢铁定制）
    cancelVisit: function cancelVisit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Dialog.confirm({
                  title: '提示',
                  message: '确定要提前结束访问？'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this.$api.Visit.cancelVisit({
                            xh: _this.xh,
                            visitorState: 9
                          }).then(function (response) {
                            var code = response.code,
                                msg = response.msg;

                            if (+code !== 600) {
                              _this.$utils.Tools.toastShow(msg);
                            } else {
                              _this.$utils.Tools.toastShow('取消访问成功！');
                            }
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {// on cancel
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getVisitType: function getVisitType() {
      var _this2 = this;

      this.$api.Visit.getVisitType().then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== 600) {
          _this2.$utils.Tools.toastShow(msg);
        } else {
          _this2.visitType = data;
          setTimeout(function () {
            _this2.drawImage();
          }, 0);
        }
      }).catch(function (err) {
        _this2.$utils.Tools.httpError(err);
      });
    },

    /**
     *  function获取访客基本信息
     *  @wzx
     *  @2019-04-01
     **/
    getVisitorInfo: function getVisitorInfo(xh) {
      var _this3 = this;

      this.$utils.Tools.loadShow();
      this.$api.Visit.selectByPrimaryKey(xh).then(function (response) {
        _this3.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this3.$code.success) {
          _this3.$utils.Tools.toastShow(msg);
        } else {
          _this3.visitor = data.visUserEntity;

          if (!_this3.visitor.compName) {
            _this3.visitor.compName = '个人';
          }

          _this3.register = data.visRegisterEntity; // this.drawImage();

          _this3.getVisitType();
        }
      }).catch(function (err) {
        _this3.$utils.Tools.httpError(err);
      });
    },
    getSysDate: function getSysDate() {
      var _this4 = this;

      this.$utils.Tools.loadShow();
      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        _this4.$utils.Tools.loadShow();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this4.$code.success) {
          _this4.$utils.Tools.toastShow(msg);
        } else {
          _this4.currDate = data.sysDate;
        }
      }).catch(function (err) {
        _this4.$utils.Tools.httpError(err);
      });
    },
    drawImage: function drawImage() {
      var _this5 = this;

      var inviteBox = document.getElementById('visit-all');
      var canvas = document.createElement('canvas');
      canvas.width = 840; // 最终图片宽度280px的2倍，以px为单位

      canvas.height = 1050; // 最终图片高度350px的2倍，以px为单位

      var opts = {
        canvas: canvas,
        // 将自定义canvas作为配置项
        useCORS: true // 允许图片跨域

      };
      window.html2canvas(inviteBox, opts).then(function (canvas) {
        /* 此处的base64ImgSrc就是得到的img的base64字符串，直接在页面上显示即可 */
        var base64ImgSrc = canvas.toDataURL('image/png');
        _this5.saveImgUrl = base64ImgSrc;
      });
    }
  },
  created: function created() {
    this.xh = this.$route.query.xh || decodeURIComponent(this.$utils.Tools.getUrlParams('state')).split(',')[0];
    this.getVisitorInfo(this.xh); // this.getVisitType();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
};